const validMessage = function (message) {
	const cf7notify = UIkit.notification(message, { status:'success',timeout: '3600' })
};

const errorMessage = function (message) {
	const cf7notify = UIkit.notification(message, {status:'warning', timeout: '3600' })
};

const cf7Events = function () {
	console.log("cf7Events.js ready!");

	var wpcf7Elm = document.querySelectorAll(".wpcf7");

	for (let i = 0; i < wpcf7Elm.length; i++) {
		
		// if (wpcf7Elm != undefined) {
		// 	console.log("wpcf7Elm found");

			wpcf7Elm[i].addEventListener(
				"wpcf7invalid",
				function (event) {
					const id = wpcf7Elm[i].id;
					const formWrapper = document.getElementById(wpcf7Elm[i].id);
					const messageOutput = document
						.getElementById(wpcf7Elm[i].id)
						.getElementsByClassName("wpcf7-response-output")[0];

					//hide cf7 response div
					messageOutput.style.display = "none";

					//delay while waiting for text render
					setTimeout(function () {
						let message = messageOutput.innerText;
						errorMessage(message);
					}, 50);
				},
				false
			);

			wpcf7Elm[i].addEventListener(
				"wpcf7mailfailed",
				function (event) {
					const id = wpcf7Elm.id;
					const formWrapper = document.getElementById(wpcf7Elm[i].id);
					const messageOutput = document
						.getElementById(wpcf7Elm[i].id)
						.getElementsByClassName("wpcf7-response-output")[0];

					//hide cf7 response div
					messageOutput.style.display = "none";

					//delay while waiting for text render
					setTimeout(function () {
						let message = messageOutput.innerText;
						errorMessage(message);
					}, 50);
				},
				false
			);

			wpcf7Elm[i].addEventListener(
				"wpcf7mailsent",
				function (event) {
					const id = wpcf7Elm[i].id;
					const formWrapper = document.getElementById(wpcf7Elm[i].id);
					const messageOutput = document
						.getElementById(wpcf7Elm[i].id)
						.getElementsByClassName("wpcf7-response-output")[0];

					//hide cf7 response div
					messageOutput.style.display = "none";

					//delay while waiting for text render
					setTimeout(function () {
						let message = messageOutput.innerText;
						validMessage(message);
					}, 50);
				},
				false
			);
		}
	// })
};
cf7Events();